<script lang="ts">
  import { pop } from "svelte-spa-router";
  import ListNavigationItem from "$shared/components/ListNavigationItem.svelte";
  import Separator from "$shared/components/Separator.svelte";
  import CardInline from "$shared/components/CardInline.svelte";
  import CustomButton from "$shared/components/CustomButton.svelte";
  import { LoadingIndicator, Toast } from "$components";
  import { formatDate } from "$shared/utils/dateTime";
  import api from "$shared/lib/api-parkito2.svelte.ts";
  import { asyncDerived } from "@square/svelte-store";
  import { ModalDialog } from "$components";
  import { myPages } from "../stores/myPagesData.svelte.ts";

  export let params: { id: string; spotid: string; spotsharingid: string };

  const spotShare = asyncDerived(
    [],
    () => api.getSpotShare({ path: { id: params.spotsharingid } }),
  );
  spotShare.subscribe((ss) => {
    if (ss && ss.error) {
      Toast.error("Kunde inte hämta platsdelning");
    }
  });

  let showRemoveDialog: boolean = false;

  const toggleRemoveDialog = () => {
    showRemoveDialog = !showRemoveDialog;
  };

  const removeSpotSharing = async () => {
    const res = await api.deleteSpotShare({
      path: { id: params.spotsharingid },
    });
    if (res.data) {
      Toast.info("Platsdelningen har raderats");
      $myPages.reload();
      pop();
    } else {
      Toast.error("Borttagning misslyckades");
    }
  };
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      on:click={() => {
        pop();
      }}
      class="-ml-[8px]"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      Platsdelning
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  <div
    class="w-full min-[840px]:columns-2 columns-1 p-[24px] max-mobile:px-[8px]"
  >
    {#await spotShare.load()}
      <LoadingIndicator visible />
    {:then}
      {#if $spotShare.data}
        <CardInline title="Platsdelning">
          <ListNavigationItem
            title="Giltig från"
            textRight={formatDate($spotShare.data.validFrom, "YYYY-MM-DD HH:mm") ??
              "-"}
            isFirst={true}
          />
          <ListNavigationItem
            title="Giltig till"
            textRight={$spotShare.data.validUntil
              ? formatDate($spotShare.data.validUntil, "YYYY-MM-DD HH:mm")
              : "Tills vidare"}
          />
          <ListNavigationItem
            title="Tilldelat konto"
            textRight={$spotShare.data.sentToEmail}
          />
          <ListNavigationItem
            title="Status"
            textRight={$spotShare.data.acceptedAt
              ? "Aktiv"
              : "Inbjuden, väntar på svar"}
            isLast={true}
          />

          <CustomButton
            type="warning"
            onClick={toggleRemoveDialog}
            customClass="mt-[32px] w-full !max-w-full !h-[50px]"
          >
            Ta bort
          </CustomButton>
        </CardInline>
      {:else}
        något gick gfel
      {/if}
    {/await}
  </div>

  <!-- Show remove spot sharing modal dialog -->
  {#if showRemoveDialog}
    <ModalDialog onBackdropPressed={toggleRemoveDialog}>
      <div class="px-[24px] py-[24px] max-mobile:px-[16px]">
        <h2 class="text-[#181818] text-[18px]">Ta bort platsdelning</h2>
      </div>
      <Separator />
      <div class="px-[24px] py-[16px] max-mobile:px-[16px]">
        <p>Platsdelningen kommer att tas bort.</p>
        <div class="flex pt-[24px] justify-end">
          <CustomButton
            type="ghost"
            onClick={toggleRemoveDialog}
            customClass="mr-[8px]"
          >Avbryt</CustomButton>
          <CustomButton
            type="warning"
            onClick={removeSpotSharing}
            customClass="w-[200px]"
          >Radera</CustomButton>
        </div>
      </div>
    </ModalDialog>
  {/if}
</div>
